import React, { useState, useRef } from "react";
import { useCalendar } from "../context/CalendarContext";
import { DayData, ColorOption, DayColors } from "../types";
import { getDate } from "date-fns";
import ColorPopover from "./ColorModal";

interface DayCellProps {
  dayData: DayData;
}

const DayCell: React.FC<DayCellProps> = ({ dayData }) => {
  const { updateDayColor, getCapacityForDay } = useCalendar();
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const dayCellRef = useRef<HTMLDivElement>(null);

  const handleDayClick = () => {
    setIsPopoverOpen(!isPopoverOpen);
  };

  const handleClosePopover = () => {
    setIsPopoverOpen(false);
  };

  const handleSelectColor = (colorKey: ColorOption) => {
    updateDayColor(dayData.date, colorKey);
    setIsPopoverOpen(false);
  };

  const textColor = dayData.color === DayColors.CINZA.background || dayData.color === DayColors.AZUL_CLARO.background ? "text-black" : "text-white";
  const capacity = getCapacityForDay(dayData);
  const tooltipText = `${dayData.type} - Capacidade: ${capacity.toLocaleString("pt-BR")}`;

  return (
    <>
      <div
        ref={dayCellRef}
        className={`border rounded p-0.5 h-10 flex flex-col justify-center items-center cursor-pointer hover:ring-2 hover:ring-offset-1 hover:ring-indigo-500 transition-all duration-150 ${dayData.color} ${textColor}`}
        onClick={handleDayClick}
        title={tooltipText}
      >
        <span className="text-sm font-medium">{getDate(dayData.date)}</span>
      </div>
      {isPopoverOpen && (
        <ColorPopover
          isOpen={isPopoverOpen}
          onClose={handleClosePopover}
          onSelectColor={handleSelectColor}
          currentDay={dayData.date}
          targetElement={dayCellRef.current}
        />
      )}
    </>
  );
};

export default DayCell;

